import { useQuery } from '@tanstack/react-query';
import { CurrencyService } from 'src/api/generated';
import type { TenantCurrencyConfigResponse } from 'src/api/generated';
import type { ApiResponse } from 'src/hooks/api/api';
import { MINUTE_IN_MS } from 'src/utils/date';

export interface UseTenantCurrencyConfigResult extends ApiResponse {
  config: TenantCurrencyConfigResponse | undefined;
}

export const useTenantCurrencyConfig = (): UseTenantCurrencyConfigResult => {
  const {
    data,
    error,
    isLoading: loading,
    refetch,
  } = useQuery<TenantCurrencyConfigResponse, Error>({
    queryKey: ['currency/config'],
    queryFn: () => CurrencyService.getTenantCurrencyConfig(),
    staleTime: MINUTE_IN_MS * 5,
  });

  return {
    config: data,
    loading,
    error: error ?? null,
    refetch,
  };
};
